"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = speakActivityAndStartDictateOnIncomingActivityFromOthersSaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _incomingActivity = require("../actions/incomingActivity");

var _markActivity = _interopRequireDefault(require("../actions/markActivity"));

var _shouldSpeakIncomingActivity = _interopRequireDefault(require("../selectors/shouldSpeakIncomingActivity"));

var _speakableActivity = _interopRequireDefault(require("../definitions/speakableActivity"));

var _startDictate = _interopRequireDefault(require("../actions/startDictate"));

var _stopDictate = _interopRequireDefault(require("../actions/stopDictate"));

var _whileConnected = _interopRequireDefault(require("./effects/whileConnected"));

var _marked =
/*#__PURE__*/
_regenerator["default"].mark(speakActivityAndStartDictateOnIncomingActivityFromOthers),
    _marked2 =
/*#__PURE__*/
_regenerator["default"].mark(speakActivityAndStartDictateOnIncomingActivityFromOthersSaga);

function speakActivityAndStartDictateOnIncomingActivityFromOthers(_ref) {
  var userID;
  return _regenerator["default"].wrap(function speakActivityAndStartDictateOnIncomingActivityFromOthers$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          userID = _ref.userID;
          _context2.next = 3;
          return (0, _effects.takeEvery)(function (_ref2) {
            var payload = _ref2.payload,
                type = _ref2.type;
            return type === _incomingActivity.INCOMING_ACTIVITY && payload.activity.from.id !== userID;
          },
          /*#__PURE__*/
          _regenerator["default"].mark(function _callee(_ref3) {
            var activity, shouldSpeakIncomingActivity, shouldSpeak;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    activity = _ref3.payload.activity;
                    _context.next = 3;
                    return (0, _effects.select)(_shouldSpeakIncomingActivity["default"]);

                  case 3:
                    shouldSpeakIncomingActivity = _context.sent;
                    shouldSpeak = (0, _speakableActivity["default"])(activity) && shouldSpeakIncomingActivity;

                    if (!(shouldSpeak && (activity.speak || activity.text))) {
                      _context.next = 8;
                      break;
                    }

                    _context.next = 8;
                    return (0, _effects.put)((0, _markActivity["default"])(activity, 'speak', true));

                  case 8:
                    if (!(shouldSpeak && activity.inputHint === 'expectingInput')) {
                      _context.next = 13;
                      break;
                    }

                    _context.next = 11;
                    return (0, _effects.put)((0, _startDictate["default"])());

                  case 11:
                    _context.next = 16;
                    break;

                  case 13:
                    if (!(activity.inputHint === 'ignoringInput')) {
                      _context.next = 16;
                      break;
                    }

                    _context.next = 16;
                    return (0, _effects.put)((0, _stopDictate["default"])());

                  case 16:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

        case 3:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked);
}

function speakActivityAndStartDictateOnIncomingActivityFromOthersSaga() {
  return _regenerator["default"].wrap(function speakActivityAndStartDictateOnIncomingActivityFromOthersSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _whileConnected["default"])(speakActivityAndStartDictateOnIncomingActivityFromOthers);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked2);
}